import { getLocalPath } from '../../../utility/config/configuration'
import { getRelativeAssetBasePath } from '../../../../global/environments/path.js'
import trim from 'lodash/trim'
import { isInvestor } from '../../../../global/authentication/authentication-manager.js'
const apiBasePath = `${getLocalPath()}/halapi/documents`
export const prospectusType = [
  'summaryProspectus',
  'prospectus',
  'statementofAdditionalInformation',
]
export const shareHolderReports = [
  'semiAnnualFinancialStatements',
  'annualFinancialStatements',
  'annualReport',
  'semiAnnualReport',
  'firstQtrReport',
  'thirdQtrReport',
]
export const removeFilters = [
  'Product Guide',
  'Reports',
  'Annual Financial Statements and Additional Information',
  'Semiannual Financial Statements and Additional Information',
]
export const DEFAULT_CLASSES = {
  'mutual-funds': 'Institutional',
  'variable-products': '1',
  'interval-funds': 'Institutional',
}
export const DEFAULT_PRODUCT = 'mutual-funds'
export const productTypes = {
  'mutual-funds': {
    label: 'Mutual Funds',
    isEnabled: true,
  },
  'exchange-traded-funds': {
    label: 'Exchange Traded Funds (ETFs)',
    isEnabled: !isInvestor(),
  },
  'variable-products': {
    label: 'Variable Products',
    isEnabled: true,
  },
  'closed-end-funds': {
    label: 'Listed Closed-End Funds',
    isEnabled: true,
  },
  'sma-completion-portfolios': {
    label: 'Separately Managed Accounts',
    isEnabled: !isInvestor(),
  },
  'interval-funds': {
    label: 'Interval Funds',
    isEnabled: true,
  },
}

export const getSummaryProspectusAndMailOrderAndLiterature = async () => {
  const url = `${apiBasePath}?_scope=/content/documents/administration/cti-common&_expr=jcr:contains(@resourcebundle:id, 'summary.prospectus.details') or jcr:contains(@resourcebundle:id, 'mail.order.details')  or jcr:contains(@resourcebundle:id, 'literature.doctypes')`
  const response = await fetch(url)
  if (!response.ok) {
    console.log(response.status, url)
    return {}
  }
  return await response.json()
}

export const getSummaryProspectus = async (cusip) => {
  const url = `${apiBasePath}?_scope=/content/documents/cti-advisor/common/summary-prospectus&_limit=-1${
    !cusip ? '' : `&_expr=@ctifund:cusip='${cusip}'`
  }`
  const response = await fetch(url)
  if (!response.ok) {
    console.log(JSON.stringify(response.status, url))
    return {}
  }
  return await response.json()
}

export const getProductFund = async (productName) => {
  const url = `${apiBasePath}?_scope=/content/documents/cti-advisor/products/${productName}/funds&_fields=fundCategory&_limit=-1`
  const response = await fetch(url)
  if (!response.ok) {
    console.log(response.status, url)
    return {}
  }
  return await response.json()
}

export const getProductsClasses = async (productName) => {
  const url = `${apiBasePath}?_scope=/content/documents/cti-advisor/products/${productName}/classes&_sort=ctifund:title&_fields=title,cusipId,symbol,classCategory,productDocuments,fundName&_expr=@ctifund:status='1'&_limit=-1`
  const response = await fetch(url)
  if (!response.ok) {
    console.log(response.status, url)
    return {}
  }
  return await response.json()
}

export const getRIAProductsClasses = async (productName) => {
  const url = `${apiBasePath}?_scope=/content/documents/cti-advisor/products/${productName}/classes&_sort=ctifund:title&_fields=title,cusipId,symbol,classCategory,productDocuments,fundName,closedFundMsg&_expr=@ctifund:status='1',@ctifund:type='RIA'${
    productName === 'mutual-funds' ? ",@ctifund:fundClass='Institutional2'" : ''
  }&_limit=-1`
  const response = await fetch(url)
  if (!response.ok) {
    console.log(JSON.stringify(response.status, url))
    return {}
  }
  return await response.json()
}

export const getRiaData = async (productName) => {
  const classData =
    (await getRIAProductsClasses(productName))._embedded?.documents || []
  const _classData = []
  for (let x = 0; x < classData.length; x++) {
    const fund = classData[x]
    const _documents = []
    fund?.productDocuments?.forEach((i) => {
      const url = `/binaries/${i?.file?._meta?.mirror?.path}`

      if (
        ['Fact Sheet', 'Fund Commentary', 'Attribution/Contribution'].includes(
          i.docType
        )
      ) {
        _documents.push({
          docType: i?.docType,
          label: i?.ucmRefId,
          url,
          secureDoc: url?.includes('/secure/') || false,
        })
      }
    })
    const classInfo = {
      fundName: trim(
        fund?.title?.includes('Class')
          ? fund?.title?.slice(0, fund?.title?.lastIndexOf('-'))
          : fund?.title
      ),
      fundClass: fund?.classCategory,
      cusip: fund?.cusipId,
      symbol: fund?.symbol,
      documents: _documents,
    }
    _classData.push(classInfo)
  }
  return _classData
}

export const getFundData = async (productName = DEFAULT_PRODUCT, docInfo) => {
  const fundData =
    (await getProductFund(productName))?._embedded?.documents || []
  const classData =
    (await getProductsClasses(productName))?._embedded?.documents || []
  const _fundData = fundData?.reduce(
    (p, n) => ({ ...p, [n?._meta?.id]: n?.fundCategory }),
    {}
  )
  const _classData = []
  let _classOptions = {}
  let _filters = {}
  for (let j = 0; j < classData?.length; j++) {
    const i = classData[j]
    let classInfo = {
      fundClass: i?.classCategory,
      fundName: trim(
        i?.title?.includes('Class')
          ? i?.title?.slice(0, i?.title?.lastIndexOf('-'))
          : i?.title
      ),
    }
    const documents = getDocuments(i, docInfo)
    for (let k = 0; k < documents?.length; k++) {
      const d = documents[k]
      if (k === 0) {
        classInfo = {
          ...classInfo,
          cusip: i?.cusipId,
          symbol: i?.symbol,
          productType: productTypes[productName]?.label,
          fundGroup: _fundData[i?.fundName?._meta?.mirror?.id] || 'Retail',
        }
      }
      classInfo = { ...classInfo, ...d }
      _classData.push(classInfo)
      _filters = { ..._filters, [d.docType]: d.docType }
    }

    _classOptions = {
      ..._classOptions,
      [i?.classCategory]:
        i?.classCategory === 'null' ? 'None' : i?.classCategory,
    }
  }

  if (productName === 'sma-completion-portfolios') {
    _filters = await getManagedAccountsData(
      _classData,
      docInfo.mailOrderDetail,
      _filters
    )
  }

  _classOptions = Object.keys(_classOptions).map((i) => ({
    key: i,
    label: _classOptions[i],
  }))
  _filters = Object.keys(_filters)?.reduce(
    (p, n) => (_filters[n] && !removeFilters.includes(n) ? [...p, n] : p),
    []
  )
  return {
    funds: _classData,
    classOptions: _classOptions,
    filters: _filters,
  }
}

export const getInitDocData = async (documentInfo = {}, cusip) => {
  const summaryData =
    (await getSummaryProspectus(cusip))?._embedded?.documents || []
  const data = await getSummaryProspectusAndMailOrderAndLiterature()
  const docInfo = {
    ...documentInfo,
    summaryProspectData: summaryData.reduce((p, { cusip, ...rest }) => {
      delete rest._links
      delete rest._meta
      return {
        ...p,
        [cusip]: { ...rest },
      }
    }, {}),
  }
  data?._embedded?.documents?.forEach((d) => {
    if (d.basename === 'literature.doctypes') {
      docInfo.literatureDoctypes = d.bundles.default
    } else if (d.basename === 'summary.prospectus.details') {
      docInfo.prospectusDetail = d.bundles.default
    } else if (d.basename === 'mail.order.details') {
      docInfo.mailOrderDetail = d.bundles.default
    }
  })
  return docInfo
}

const getDocuments = (
  item,
  { summaryProspectData, literatureDoctypes, prospectusDetail, mailOrderDetail }
) => {
  const currentProspectus = summaryProspectData[item?.cusipId]
  const documents = []
  item?.productDocuments?.forEach((i) => {
    const url = `/binaries/${i?.file?._meta?.mirror?.path}`

    if (
      (isInvestor() && i.displayLiterature && i.displayInvestor) ||
      (!isInvestor() && i.displayLiterature)
    ) {
      documents.push({
        byEmailOrder: mailOrderDetail[i?.ucmRefId] || 'false',
        docType: i?.docType,
        fileName: i?.ucmRefId,
        url,
        secure: url?.includes('/secure/') || false,
      })
    }
  })

  const reportsData = [...prospectusType, ...shareHolderReports]

  reportsData.forEach((p) => {
    if (currentProspectus && currentProspectus[p]) {
      const fileName = prospectusDetail[p]
      const url = `${prospectusDetail?.domain}/${item?.cusipId}/${literatureDoctypes[fileName]}`
      documents.push({
        byEmailOrder: mailOrderDetail[fileName] || 'false',
        docType: shareHolderReports.includes(p)
          ? 'Shareholder Reports'
          : fileName,
        fileName: fileName,
        url,
        secure: url?.includes('/secure/'),
      })
    }
  })

  return documents
}

export const filterFundByClass = (funds = [], ativeClass) =>
  ativeClass?.length < 1
    ? funds
    : funds.filter((i) => i?.fundClass === ativeClass)

export const transfromRowForTable = (data = [], filterBy, search, type) => {
  let result = [...data]
  if (filterBy?.length > 0) {
    result = result?.filter((i) =>
      type === 'funds'
        ? filterBy.includes(i?.docType)
        : filterBy.includes(i?.documentType)
    )
  }

  if (search?.length > 0) {
    result = result?.filter((i) =>
      type === 'funds'
        ? i?.fundName?.toLowerCase()?.includes(search?.toLowerCase())
        : i?.title?.toLowerCase()?.includes(search?.toLowerCase())
    )
  }

  return result
}

export const getFormsAndApps = async () => {
  const site = isInvestor() ? 'investor' : 'advisor'
  const url = `${getLocalPath()}/halapi/cti:FormsAndApplications?_scope=/content/documents/cti-${site}/resources/forms-and-applications&_sort=cti:productType&_limit=-1`
  const response = await fetch(url)
  if (!response.ok) {
    console.log(JSON.stringify(response.status, url))
    return {}
  }
  return (await response.json())._embedded?.documents
}

const getManagedAccountsDocument = async () => {
  const url = `${getLocalPath()}/halapi/cti:Accordion?_scope=/content/documents/cti-advisor/products/managed-accounts&_limit=-1`
  const response = await fetch(url)
  if (!response.ok) {
    console.log(JSON.stringify(response.status, url))
    return {}
  }
  return await response.json()
}

const getManagedAccountsData = async (
  _classData,
  mailOrderDetail,
  _filters
) => {
  const documentData =
    (await getManagedAccountsDocument())?._embedded?.documents || []

  const links = documentData
    .map((section) =>
      section.OuterAccordionCompound?.map((outerAccordionCompound) =>
        outerAccordionCompound.contentBlock.map((fund) =>
          fund.LinkList?.links
            ? fund.LinkList.links.map((link) => ({
                ...link,
                fundName: fund.innerLabel,
              }))
            : fund.links
              ? fund.links.map((link) => ({
                  ...link,
                  fundName: outerAccordionCompound.outerLabel,
                }))
              : null
        )
      )
    )
    .flat(3)
    .filter((link) => link !== null)

  for (let i = 0; i < links.length; i++) {
    const _url = links[i].Link[0].string
      ? links[i].Link[0].string
      : links[i].Link[0]._meta.mirror?.path
        ? getRelativeAssetBasePath() + '/' + links[i].Link[0]._meta.mirror.path
        : ''

    if (_url.length) {
      const _fileName = links[i].text
        .replaceAll('<p>', '')
        .replaceAll('</p>', '')
        .replaceAll('(PDF)', '')
        .trim()
      const classInfo = {
        byEmailOrder: mailOrderDetail[_fileName] || 'false',
        cusip: 'null',
        docType: [
          'Annual Report',
          'Semiannual Report',
          'First Quarter Report',
          'Third Quarter Report',
        ].includes(_fileName)
          ? 'Shareholder Reports'
          : _fileName,
        fileName: _fileName,
        fundClass: 'null',
        fundGroup: 'Managed Accounts',
        fundName: links[i].fundName,
        productType: 'Managed Accounts',
        secure: _url?.includes('/secure/'),
        symbol: '',
        url: _url,
      }
      _classData.push(classInfo)
      _filters = { ..._filters, [classInfo.docType]: classInfo.docType }
    }
  }
  return _filters
}
